import { Component } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';

import { MSISDNCONFIRMVIEWLABELS } from '../../_constants/constants';
import { CustomerService } from '../../_services/customer.service';
import { SmsURLService } from '../../_services/smsurl.service';
import { MSISDNupdateComponent } from './msisdn.update.dialog.component';

export interface MsisdnconfirmUpdateModel {
    title: string;
    // current_msisdn_label: string;
    // new_msisdn_label: string;
    description: string;
    oldMsisdn: string;
    subValue: string;
    opcoValue: string;
    customerService: CustomerService;
    smsurlService: SmsURLService;
}

@Component({
    templateUrl: 'msisdn.confirm.dialog.component.html'
})

export class MSISDNconfirmComponent extends DialogComponent<MsisdnconfirmUpdateModel, string> implements MsisdnconfirmUpdateModel {
    subValue: string;
    opcoValue: string;
    title: string;
    // new_msisdn_label = 'New Phone Number';
    // current_msisdn_label = 'Current Phone Number';
    oldMsisdn: string;
    newMsisdn: string;
    description: string;
    msisdnconfirmviewlabels = MSISDNCONFIRMVIEWLABELS;
    customerService: CustomerService;
    smsurlService: SmsURLService;

    constructor(private ds: DialogService) {
        super(ds);
    }

    apply() {
       // this.confirmUpdateMSISDN(this.newMsisdn, this.subValue, this.opcoValue, this.ds);
        this.ds.addDialog(MSISDNupdateComponent, {
          title: 'Msisdnupdate dialog', oldMsisdn: this.customerService.getPerson().phone_number,
          subValue: this.subValue,
          opcoValue: this.opcoValue,
          customerService: this.customerService,
          smsurlService: this.smsurlService
        });
        this.close();
    }
}




// WEBPACK FOOTER //
// ./src/app/details/msisdnupdate/msisdn.confirm.dialog.component.ts